import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {formatCount, formatDuration} from '../../../utils/format';
import {Placeholder} from '../../../library/cards/card';
import GithubIcon from '../../../library/icons/social/github-large.svg';
import StarIcon from '../../../library/icons/star.svg';
import ForkIcon from '../../../library/icons/fork.svg';
import CalendarIcon from '../../../library/icons/calendar.svg';
import {TABLET} from '../../../style/breakpoints';
import StatsCard from '../../../library/cards/stats';
import {MOBILE_PADDING} from '../card';

const DESKTOP_MARGIN = 20;
const MOBILE_MARGIN = 25;

const ICON_SIZE = 22;

const iconStyles = {
  height: ICON_SIZE,
  width: ICON_SIZE
};

const StyledStarIcon = glamorous(StarIcon)(iconStyles);
const StyledForkIcon = glamorous(ForkIcon)(iconStyles);
const StyledCalendarIcon = glamorous(CalendarIcon)(iconStyles);

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  [TABLET]: {
    padding: MOBILE_PADDING
  }
});

const Card = glamorous.div({
  marginLeft: 15,
  [TABLET]: {
    marginTop: 15
  },
  ' > div > div': {
    marginRight: DESKTOP_MARGIN,
    [TABLET]: {
      marginRight: MOBILE_MARGIN
    }
  }
});

const Content = glamorous.a({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  [TABLET]: {
    flexDirection: 'column'
  },
  textDecoration: 'none'
});

const StyledGithubIcon = glamorous(GithubIcon)({
  height: 50,
  width: 50,
  [TABLET]: {
    height: 32,
    width: 32
  }
});

const GithubStatsCard = ({stars = 0, forks = 0, lastUpdated = null, url = null}) => {
  const placeholder = '- No public GitHub repository available -';
  let items = [];
  if (stars > 0) {
    items.push({icon: <StyledStarIcon />, stat: formatCount(stars), label: 'GitHub Stars'});
  }
  if (forks > 0) {
    items.push({icon: <StyledForkIcon />, stat: formatCount(forks), label: 'GitHub Forks'});
  }
  if (lastUpdated !== null) {
    items.push({
      icon: <StyledCalendarIcon />,
      stat: formatDuration(lastUpdated),
      label: 'Last Commit'
    });
  }
  return (
    <Container>
      {items.length > 0 ? (
        <Content href={url ? url : ''} target="_blank">
          <StyledGithubIcon />
          <Card>
            <StatsCard tooltip={true} items={items} />
          </Card>
        </Content>
      ) : (
        <Placeholder>{placeholder}</Placeholder>
      )}
    </Container>
  );
};

GithubStatsCard.propTypes = {
  stars: PropTypes.number,
  forks: PropTypes.number,
  lastUpdated: PropTypes.string,
  url: PropTypes.string
};

export default GithubStatsCard;
